export default __webpack_public_path__ + "static/media/img5.589f4dd9.PNG";